import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import { useProgramStore } from './stores/programStore';

const app = createApp(App);
const pinia = createPinia();

app.use(pinia);
app.use(router);

const mountEl = document.getElementById('app');

if (mountEl) {
	const mode = mountEl.getAttribute('data-start');

	// Set start state before mounting
	const store = useProgramStore(pinia);
	store.setStartView(mode === 'results' ? 'results' : 'filter');

	// check for params passed from filter query
	const hash = window.location.hash;

	// Split on "?" to isolate query string
	const queryString = hash.includes('?') ? hash.split('?')[1] : '';

	// get the params
	const params = new URLSearchParams(queryString);

	// get and store query params in Pinia for access app-wide
	const keyword = params.get('keyword') || '';
	const interests = params.get('interests')?.split(',') || [];
	const types = params.get('types')?.split(',') || [];

	store.keyword = keyword;
	store.interests = interests;
	store.types = types;

	if (mode === 'results') {
		void router.push({
			path: '/results',
			query: { keyword, interests: interests.join(','), types: types.join(',') },
		});
	} else {
		void router.push('/');
	}

	app.mount(mountEl);
}
